import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {TokenService} from '../token/token.service';
import {IdService} from "../id/id.service";
import {PermissionsService} from "../permissions/permissions.service";

@Injectable()
export class TokenGuardService  {

    constructor(
        private id: IdService,
        private token: TokenService,
        private router: Router,
        private featureFlagService: PermissionsService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
    // Get and set token if available
        this.token.getToken(route.params, route.queryParams);

        if (this.token.isTokenPresent()) {
            // If token present, remove user token and allow route change
            this.id.ent_9105 = this.featureFlagService.isFeatureActivated('ENT-9105-PENETRATION-TEST-2025');
            this.id.removeToken();

            return true;
        } else {
            // If no token is present navigate user to root and let routing permissions handle navigation
            this.router.navigate(['/']);

            return false;
        }
    }
}
